import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['base', 'active', 'complete', 'invalid', 'textContent', 'textDescription', 'border']
  static classes = ['hidden', 'base', 'invalid', 'active', 'borderActive', 'borderInvalid', 'borderComplete'];
  static values = { active: Boolean, state: String }

  connect() {
    this.element[this.identifier] = this;

    if (this.hasState) {
      this.setBase();
      this.setActive(this.activeValue);
    }
  }

  get hasState() {
    return this.element.hasAttribute('data-attributes-state');
  }

  get hasValidation() {
    return this.element.hasAttribute('data-attributes-validate');
  }

  get currentState() {
    return this.stateValue;
  }

  activeValueChanged() {
    this.setActive(this.active);
  }

  stateValueChanged() {
    switch(this.stateValue) {
      case 'base':
        this.removeActive();
        this.removeComplete();
        this.removeInvalid();
        this.addBase();
        break;
      case 'active':
        this.removeComplete();
        this.removeInvalid();
        this.removeBase();
        this.addActive();
        break;
      case 'complete':
        this.removeActive();
        this.removeInvalid();
        this.removeBase();
        this.addComplete();
        break;
      case 'invalid': 
        this.removeComplete();
        this.removeBase();
        this.removeActive();
        this.addInvalid();
        break;
    }
  }

  setBase() {
    this.stateValue = 'base';
  }

  setActive(value) {
    if (value) {
      this.stateValue = 'active';
    } else {
      if (this.stateValue != 'complete' && this.stateValue != 'invalid') {
        this.stateValue = 'base';
      }
    }
  }

  setValid(value) {
    if (value) {
      this.stateValue = 'complete';
    } else {
      this.stateValue = 'invalid';
    }
  }

  setComplete(value) {
    if (value) {
      this.stateValue = 'complete';
    } else {
      this.stateValue = 'base';
    }
  }

  setVisible(value) {
    this.active = value;
  }

  addInvalid() {
    if (this.hasInvalidTarget) {
      this.invalidTarget.classList.remove(...this.hiddenClass.split(" "));
      this.textContentTarget.classList.add(...this.invalidClass.split(" "));
      this.textDescriptionTarget.classList.add(...this.invalidClass.split(" "));
      this.borderTarget.classList.add(...this.borderInvalidClass.split(" "));
    }
  }

  removeInvalid() {
    if (this.hasInvalidTarget) {
      this.invalidTarget.classList.add(...this.hiddenClass.split(" "));
      this.textContentTarget.classList.remove(...this.invalidClass.split(" "));
      this.textDescriptionTarget.classList.remove(...this.invalidClass.split(" "));
      this.borderTarget.classList.remove(...this.borderInvalidClass.split(" "));
    }
  }

  addActive() {
    if (this.hasActiveTarget) {
      this.activeTarget.classList.remove(...this.hiddenClass.split(" "));
      this.borderTarget.classList.add(...this.borderActiveClass.split(" "));
      this.textContentTarget.classList.add(...this.activeClass.split(" "));
      this.textDescriptionTarget.classList.add(...this.activeClass.split(" "));
    }
  }

  removeActive() {
    if (this.hasActiveTarget) {
      this.activeTarget.classList.add(...this.hiddenClass.split(" "));
      this.textContentTarget.classList.remove(...this.activeClass.split(" "));
      this.textDescriptionTarget.classList.remove(...this.activeClass.split(" "));
      this.borderTarget.classList.remove(...this.borderActiveClass.split(" "));
    }
  }

  addComplete() {
    if (this.hasCompleteTarget) {
      this.completeTarget.classList.remove(...this.hiddenClass.split(" "));
      this.borderTarget.classList.add(...this.borderCompleteClass.split(" "));
    }
  }

  removeComplete() {
    if (this.hasCompleteTarget) {
      this.completeTarget.classList.add(...this.hiddenClass.split(" "));
      this.borderTarget.classList.remove(...this.borderCompleteClass.split(" "));
    }
  }

  addBase() {
    if (this.hasBaseTarget) {
      this.baseTarget.classList.remove(...this.hiddenClass.split(" "));
      this.textContentTarget.classList.add(...this.baseClass.split(" "));
      this.textDescriptionTarget.classList.add(...this.baseClass.split(" "));
    }
  }

  removeBase() {
    if (this.hasBaseTarget) {
      this.baseTarget.classList.add(...this.hiddenClass.split(" "));
      this.textContentTarget.classList.remove(...this.baseClass.split(" "));
      this.textDescriptionTarget.classList.remove(...this.baseClass.split(" ")); 
    }
  }
}